// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

const getTextControl = state => state.textControl;

export const getServerErrors = createSelector(getTextControl, textControl => textControl.get('server_errors'));

export const getIsLoading = createSelector(getTextControl, textControl => textControl.get('loading'));

export const getTextControlContacts = createSelector(getTextControl, textControl =>
    textControl.get('contacts', fromJS([]))
);

export const getIsSaving = createSelector(getTextControl, textControl => textControl.get('saving'));

export const getHasError = createSelector(getTextControl, textControl => textControl.get('hasError'));



// WEBPACK FOOTER //
// ./src/core/state/text-control/selectors.js